import React from "react";

import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { GetApp } from "@mui/icons-material";
import Moment from "moment";

import { ButtonContactGreen } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const ExcelClientListReport = ({ excelData, fileName, disabled }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const fileExtension = ".xlsx";
  let transformedData = [];

  const columnHeaders = {
    nombres: "Nombres",
    apellidos: "Apellidos",
    cliente: "Cliente",
    documento: "Documento",
    email: "Email",
    registro: "Registro",
    dependientes: "Dependientes",
    operador: "Gestor",
  };

  // CREAR LA LISTA CON EL MAPEADO
  if (excelData.length > 0) {
    transformedData = excelData.map((item) => {
      // Creamos un objeto vacío para cada fila
      const row = {};

      // Ahora llenamos el resto de los campos en `row`
      row.nombres = `${item.name1} ${item.name2}`;
      row.apellidos = `${item.lastName1} ${item.lastName2}`;
      row.cliente = item.allNames;
      row.documento = item.documentId;
      row.email = item.email;
      row.registro = Moment(item.createdAt).format("YYYY-MM-DD");
      row.dependientes = item.dependents.length;
      row.operador = item.user.allNames;

      // Mapeamos los encabezados con los valores correspondientes
      const mappedRow = Object.keys(row).reduce((acc, key) => {
        acc[columnHeaders[key] || key] = row[key];
        return acc;
      }, {});

      return mappedRow;
    });
  }

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(transformedData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <>
      {/*<Tooltip title={fileName}>*/}
      <ButtonContactGreen
        onClick={(e) => exportToExcel(fileName)}
        // className={className}
        startIcon={<GetApp style={{ fontSize: 14 }} />}
        disabled={disabled}
        style={{
          fontSize: 12,
        }}
      >
        {" "}
        Excel
      </ButtonContactGreen>
      {/*</Tooltip>*/}
    </>
  );
};

export default ExcelClientListReport;
